import * as types from '@/store/mutation-types'
import apolloClient from '@/api/apollo'

import CLIENT_QUERY from '@/graphql/queries/Account/Client.graphql'
import UPDATE_CLIENT_MUTATION from '@/graphql/mutations/Account/UpdateClient.graphql'
import UPDATE_CLIENT_PASSWORD_MUTATION from '@/graphql/mutations/Account/UpdateClientPassword.graphql'
import CREATE_CLIENT_EMAIL from '@/graphql/mutations/Account/CreateClientEmail.graphql'
import REMOVE_CLIENT_EMAIL from '@/graphql/mutations/Account/RemoveClientEmail.graphql'

const module = {
  namespaced: true,
  state: {
    client: null,
    lastPasswordUpdate: null
  },
  mutations: {
    [types.SET_CLIENT] (state, { client }) {
      state.client = client
    },
    setClient (state, client) {
      state.client = client
    },
    setLastPasswordUpdate (state, lastPasswordUpdate) {
      state.lastPasswordUpdate = lastPasswordUpdate
    }
  },
  actions: {
    async fetchClient ({ commit }) {
      const result = await apolloClient.query({
        query: CLIENT_QUERY
      })
      const client = result.data.fetchClient
      commit('setClient', client)
    },
    async updateClient ({ commit }, { client }) {
      const result = await apolloClient.mutate({
        mutation: UPDATE_CLIENT_MUTATION,
        variables: {
          client
        }
      })
      const updatedClient = result.data.updateClient
      commit('setClient', updatedClient)
    },
    async updateClientPassword ({ commit }, { client }) {
      await apolloClient.mutate({
        mutation: UPDATE_CLIENT_PASSWORD_MUTATION,
        variables: {
          client
        }
      })
      commit('setLastPasswordUpdate', new Date())
    },
    async createEmail ({ commit }, { email }) {
      const result = await apolloClient.mutate({
        mutation: CREATE_CLIENT_EMAIL,
        variables: {
          email
        }
      })
      const client = result.data.createClientEmail
      commit(types.SET_CLIENT, { client })
    },
    async removeEmail ({ commit }, { email }) {
      const result = await apolloClient.mutate({
        mutation: REMOVE_CLIENT_EMAIL,
        variables: {
          email
        }
      })
      const client = result.data.removeClientEmail
      commit(types.SET_CLIENT, { client })
    }
  }
}

export default module



// WEBPACK FOOTER //
// ./src/store/modules/account/index.js